// extracted by mini-css-extract-plugin
module.exports = {"Sections":"sections_Sections__D7v6C","Image":"sections_Image__ntGA9","Text":"sections_Text__qiTHl","SectionsList":"sections_SectionsList__K2WQT"};